import { makeStyles } from '@material-ui/core/styles'

const ArticleStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 443,
    margin: '0 auto 4rem auto',
    pageBreakInside: 'avoid',
  },
  cardAlt: {
    maxWidth: 289,
    margin: '0 auto 4rem',
    pageBreakInside: 'avoid',
  },
  small: {
    '& img': {
      // transform: 'scale(0.8)',
    },
  },
  first: {
    // marginTop: 78,
  },
  cardInner: {
    position: 'relative',
    backgroundColor: 'white',
    height: '100%',
  },
  cardImage: {
    '& > img': {
      display: 'block',
      width: '100%',
    },
  },
  cardImageAlt: {
    '& > img': {
      width: '100%',
      height: 400,
      objectFit: 'cover',
      display: 'block',
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 3),
    '& p': {
      margin: '1rem 0',
      fontSize: 12,
      color: theme.palette.text.secondary,
      fontWeight: 500,
      marginBottom: 0,
    },
    '& h2': {
      fontFamily: 'DomaineNArrow, serif',
      margin: '1rem 0',
      color: 'rgb(0, 36, 63)',
      fontSize: 24,
      lineHeight: '30px',
      fontWeight: 500,
      marginBottom: 0,
    },
    '& a': {
      fontSize: 14,
      color: 'rgb(0, 36, 63)',
      fontWeight: 600,
    },
    '& hr': {
      border: 'none',
      backgroundColor: '#979797',
      margin: '1rem 0',
      height: 1,
    },
  },
  cardContentAlt: {
    padding: theme.spacing(0, 1, 1, 1),
    '& p': {
      margin: '1rem 0 0 0',
      fontSize: 12,
      color: theme.palette.text.secondary,
      fontWeight: 500,
    },
    '& h2': {
      fontFamily: 'DomaineNArrow, serif',
      margin: '1rem 0',
      color: 'rgb(0, 36, 63)',
      fontSize: 24,
      lineHeight: '30px',
      fontWeight: 500,
    },
    '& a': {
      margin: '0 0 1rem 0',
      fontSize: 12,
      color: 'rgb(0, 36, 63)',
      fontWeight: 600,
    },
    '& hr': {
      border: 'none',
      backgroundColor: '#CCCCCC',
      margin: '1rem 0',
      height: 1,
    },
  },
  tags: {
    '& span': {
      display: 'inline-block',
      color: theme.palette.secondary.main,
      fontSize: 8,
      backgroundColor: 'rgba(123,202,210,0.3)',
      fontWeight: 600,
      borderRadius: 12,
      padding: '.5rem',
      lineHeight: '1',
    },
  },
}))
export default ArticleStyles
